class MapIntegration extends HTMLElement {
  constructor() {
    super();
    this.map = null;
    this.infoWindow = null;
    this.currentInfoWindow = null;
    this.markers = [];
    this.customLocations = [];
  }

  connectedCallback() {
    this.initElements();
    this.initMap();
    this.attachEventListeners();
  }

  initElements() {
    this.mapElement = this.querySelector("#map");
    this.searchBar = this.querySelector("#search-bar");
    this.resultsContainer = this.querySelector("#autocomplete-results");
    this.locationLogo = this.querySelector("#store_location_logo");
    this.locationTile = this.querySelector("#store_location_tile");
    this.locationAddress = this.querySelector("#store_location_address");
    this.locationPhone = this.querySelector("#store_location_phone");
    this.locationEmail = this.querySelector("#store_location_email");
    this.locationWebsite = this.querySelector("#store_location_website");
    this.bookingBtn = this.querySelector('.vereinbaren-btn');
    this.bookingForm = document.querySelector("#store_booking_form");
  }

  async initMap() {
    this.customLocations = window.nm.locations;
    const germanyCenter = { lat: 51.1657, lng: 10.4515 };

    this.map = new google.maps.Map(this.mapElement, {
      zoom: 6,
      center: germanyCenter,
      mapTypeControl: false,
      draggable: true,
      fullscreenControl: false,
      streetViewControl: false,
      zoomControl: true,
    });

    this.infoWindow = new google.maps.InfoWindow();
    this.addMarkers();
  }

  addMarkers() {
    this.markers = this.customLocations.map((location) => {
      const position = new google.maps.LatLng(
        parseFloat(location.latitude),
        parseFloat(location.longitude)
      );

      const marker = new google.maps.Marker({
        position,
        map: this.map,
        title: location.label,
        icon: {
          url: "https://cdn.shopify.com/s/files/1/0574/1350/1024/files/map-location-marker-93567c.png?v=1728923405", // Image URL
          scaledSize: new google.maps.Size(40, 40), // Scaled size
          origin: new google.maps.Point(0, 0), // Origin of the image
          anchor: new google.maps.Point(25, 40), // Anchor point of the image
        },
      });

      marker.addListener("click", () => this.onMarkerClick(marker, location));
      return marker;
    });

    new markerClusterer.MarkerClusterer({
      map: this.map,
      markers: this.markers,
      maxZoom: 6,
    });
  }

  onMarkerClick(marker, location) {
    if (this.currentInfoWindow) this.currentInfoWindow.close();

    this.infoWindow.setContent(`
      <div class="info-window">
          <h3>${location.label}</h3>
          <p><strong>Adresse:</strong> ${location.street}, ${location.zip_code} ${location.city}</p>
          <p><strong>Tel.:</strong> ${location.phone}</p>
          <p><a href="${location.url}" target="_blank">Website</a></p>
      </div>
    `);
    this.infoWindow.open(this.map, marker);

    this.updateLocationDetails(location);
    this.currentInfoWindow = this.infoWindow;
  }

  updateLocationDetails(location) {
    this.locationTile.textContent = location.label || "";
    this.locationAddress.textContent =
      `${location.street}, ${location.zip_code} ${location.city}` || "";
    this.locationPhone.textContent = location.phone || "";
    this.locationPhone.href = location.phone ? `tel:${location.phone}` : "";
    this.locationEmail.textContent = location.email || "";
    this.locationEmail.href = location.email ? `mailto:${location.email}` : "";
    this.locationWebsite.textContent = location.url || "";
    this.locationWebsite.href = location.url || "";
    if(location.meeting_url) this.updateMeetingURL(location.meeting_url);
    // if (location.meeting_url) {
    //   this.bookingBtn.href = location.meeting_url;

    //   if (this.bookingBtn.hasAttribute("data-bs-toggle")) {
    //     this.bookingBtn.removeAttribute("data-bs-toggle");
    //   }
    // } else {
    //   this.bookingBtn.href = "#calendar_popup";

    //   if (!this.bookingBtn.hasAttribute("data-bs-toggle")) {
    //     this.bookingBtn.setAttribute("data-bs-toggle", "modal");
    //   }
    // }
    this.updateLocationLogo(location.logo);
  }

  updateLocationLogo(logo) {
    if (!logo) {
      this.locationLogo.style.display = "none";
      this.locationLogo.src = "";
      return;
    }
    this.locationLogo.style.display = "block";
    this.locationLogo.src = logo;
  }

  updateMeetingURL(src) {
    if (!src) return; 

    if(src.startsWith("mailto:")) {
      this.bookingBtn.href = src
      this.bookingBtn.removeAttribute("data-bs-toggle");
    } else {
      this.bookingBtn.href = "#calendar_popup"
      this.bookingBtn.setAttribute("data-bs-toggle", "modal");
      
      const iframeEle = document.querySelector('#calendar_popup #store_booking_form');
      if (iframeEle) {
        iframeEle.src = src;
      }
    }
  }

  attachEventListeners() {
    this.searchBar.addEventListener("input", () => this.onSearch());
  }

  onSearch() {
    const searchTerm = this.searchBar.value.toLowerCase();
    this.resultsContainer.innerHTML = "";

    if (!searchTerm) {
      this.addMarkers();
      return;
    }

    const filteredLocations = this.customLocations.filter((location) => {
      const fullAddress =
        `${location.label} ${location.street} ${location.zip_code} ${location.city}`.toLowerCase();
      return fullAddress.includes(searchTerm);
    });

    filteredLocations.forEach((location) => {
      const resultItem = document.createElement("div");
      resultItem.classList.add("autocomplete-item");
      resultItem.textContent = `${location.label} ${location.street} ${location.zip_code} ${location.city}`;
      resultItem.addEventListener("click", () => this.selectLocation(location));
      this.resultsContainer.appendChild(resultItem);
    });
  }

  selectLocation(location) {
    const position = new google.maps.LatLng(
      parseFloat(location.latitude),
      parseFloat(location.longitude)
    );
    this.map.setCenter(position);
    this.map.setZoom(12);

    this.searchBar.value = location.label;
    this.resultsContainer.innerHTML = "";

    const selectedMarker = this.markers.find(
      (marker) =>
        marker.getPosition().lat() === position.lat() &&
        marker.getPosition().lng() === position.lng()
    );

    if (selectedMarker) {
      this.infoWindow.setContent(`
        <div class="info-window">
          <h3>${location.label}</h3>
          <p><strong>Adresse:</strong> ${location.street}, ${location.zip_code} ${location.city}</p>
          <p><strong>Tel.:</strong> ${location.phone}</p>
          <p><a href="${location.url}" target="_blank">Website</a></p>
        </div>
      `);
      this.infoWindow.open(this.map, selectedMarker);

      this.currentInfoWindow = this.infoWindow;
    }

    this.updateLocationDetails(location);
  }
}
customElements.define("map-integration", MapIntegration);

// class RezeptErfassen extends HTMLElement {
//   constructor() {
//     super();
//     this.serviceID = "service_e33bdl2";
//     this.publicKey = "0JVngWg6930HJlkVF";
//     this.templateID = "template_9trrv3p";
//   }

//   connectedCallback() {
//     emailjs.init(this.publicKey);

//     this.fileInput = this.querySelector("#file-upload-input");
//     this.fileUploadBtn = this.querySelector(".file-select-button");
//     this.fileNameDisplay = this.querySelector(".files-select-name");
//     this.vorname = this.querySelector("input[name='vorname']");
//     this.nachname = this.querySelector("input[name='nachname']");
//     this.location = this.querySelector("select[name='location']");
//     this.email = this.querySelector("input[name='email']");
//     this.telefonnummer = this.querySelector("input[name='telefonnummer']");
//     this.locationForm = this.querySelector("#location-form");
//     this.errorMessages = this.querySelector("#fileupload_popup #error-mesages");
//     this.mapLoader = this.querySelector(".fileupload-spinner");
//     this.contentWrapper = this.querySelector(".fileupload_popupWrap");

//     if (this.fileUploadBtn) {
//       this.fileUploadBtn.addEventListener("click", () => {
//         this.fileInput.click();
//       });
//     }

//     if (this.fileInput) {
//       this.fileInput.addEventListener(
//         "change",
//         this.handleFileInputChange.bind(this)
//       );
//     }

//     if (this.locationForm) {
//       this.locationForm.addEventListener(
//         "submit",
//         this.handleFormSubmit.bind(this)
//       );
//     }
//   }

//   handleFileInputChange() {
//     if (this.fileInput.files.length > 0) {
//       this.fileNameDisplay.textContent = this.fileInput.files[0].name;
//     } else {
//       this.fileNameDisplay.textContent = "Rezept Upload";
//     }
//   }

//   handleFormSubmit(event) {
//     event.preventDefault();
    
//     const selectedLocation = this.location.options[this.location.selectedIndex];
//     if (selectedLocation) {
//             this.querySelector("#to_email").value = selectedLocation.getAttribute("datastoreemail");
//     }    

//     if (this.contentWrapper) this.contentWrapper.classList.add('hidden');
//     if (this.mapLoader) this.mapLoader.classList.remove('hidden');
//     emailjs.sendForm(this.serviceID, this.templateID, this.locationForm)
//       .then((response) => {
//         if (this.mapLoader) this.mapLoader.classList.add('hidden');
//         if (this.contentWrapper) this.contentWrapper.classList.remove('hidden');

//         this.errorMessages.innerHTML = `<div class="alert alert-success" role="alert">Ihr Rezept wurde erfolgreich an die Filiale übermittelt.<br><strong>In Kürze wird sich bei Ihnen ein Mitarbeiter melden und sich persönlich um Ihre Versorgung kümmern. Bitte nehmen Sie für die Filiale Ihr Originalrezept mit.</strong></div>`;
//         this.locationForm.style.display = "none";

//         setTimeout(() => {
//           this.locationForm.reset();
//           this.locationForm.style.display = "block";
//           this.errorMessages.innerHTML = "";
//         }, 6000);
//       })
//       .catch((error) => {
//         if (this.mapLoader) this.mapLoader.classList.add('hidden');
//         if (this.contentWrapper) this.contentWrapper.classList.remove('hidden');
//         this.errorMessages.innerHTML = `<div class="alert alert-danger" role="alert">Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.</div>`;
//         console.error("EmailJS Error:", error);
//       });
//   }
// }
// customElements.define("rezept-erfassen", RezeptErfassen);
class RezeptErfassen extends HTMLElement {
  constructor() {
    super();
    this.serviceID = "service_e33bdl2";
    this.publicKey = "0JVngWg6930HJlkVF";
    this.templateID = "template_9trrv3p";
    this.storeData = window.nm.locations || [];
    this.selectedStoreLabel = null;
  }

  connectedCallback() {
    emailjs.init(this.publicKey);

    this.fileInput = this.querySelector("#file-upload-input");
    this.fileUploadBtn = this.querySelector(".form-fields-fileupload");
    this.fileNameDisplay = this.querySelector(".files-select-name");
    this.vorname = this.querySelector("input[name='vorname']");
    this.nachname = this.querySelector("input[name='nachname']");
    this.locationSelect = this.querySelector("#location");
    this.email = this.querySelector("input[name='email']");
    this.telefonnummer = this.querySelector("input[name='telefonnummer']");
    this.locationForm = this.querySelector("#location-form");
    this.errorMessages = this.querySelector("#fileupload_popup #error-mesages");
    this.mapLoader = this.querySelector(".fileupload-spinner");
    this.contentWrapper = this.querySelector(".fileupload_popupWrap");
    this.zipInput = this.querySelector("#postcode");
    this.findStoreButton = this.querySelector("#button-filialefinden");
     this.result_append = this.querySelector(".result_append");
    this.storeResult = document.createElement("div");
    this.storeResult.className = "store-results";

    this.result_append.appendChild(this.storeResult);

    if (this.fileUploadBtn) {
      this.fileUploadBtn.addEventListener("click", () => {
        this.fileInput.click();
      });
    }

    if (this.fileInput) {
      this.fileInput.addEventListener("change", this.handleFileInputChange.bind(this));
    }

   if (this.findStoreButton) {
    this.findStoreButton.addEventListener("click", (event) => {
        event.preventDefault(); // Prevent form submission
        this.findNearestStore();
    });
}
    if (this.locationForm) {
      this.locationForm.addEventListener("submit", this.handleFormSubmit.bind(this));
    }
  }

  handleFileInputChange() {
    this.fileNameDisplay.textContent = this.fileInput.files.length > 0
      ? this.fileInput.files[0].name
      : "Rezept Upload";
  }

  findNearestStore() {
    const zipCode = this.zipInput.value.trim();
    
    if (!zipCode || zipCode.length !== 5) {
      this.autoSelectDefaultLocation();
      this.storeResult.innerHTML = `<p style="color: red;">Bitte eine gültige Postleitzahl eingeben.</p>`;
      return;
    }
    
    const sortedStores = this.storeData
      .filter(store => store.zip_code && store.label !== "Warenbestand Online")
      .map(store => ({
        ...store,
        distance: Math.abs(parseInt(store.zip_code, 10) - parseInt(zipCode, 10))
      }))
      .sort((a, b) => a.distance - b.distance);

    if (sortedStores.length > 0) {
      this.autoSelectLocationByLabel(sortedStores[0].label);
      this.selectedStoreLabel = sortedStores[0].label;
    }
    
    this.storeResult.innerHTML = this.generateStoreDetails(sortedStores.slice(0, 2));
  }

  autoSelectLocationByLabel(storeLabel) {
    if (!this.locationSelect) return;

    const foundOption = Array.from(this.locationSelect.options).find(
      option => option.textContent.trim() === storeLabel
    );

    if (foundOption) {
      this.locationSelect.value = foundOption.value;
      this.selectedStoreLabel = storeLabel;
      this.updateStoreHighlight();
    }
  }

  autoSelectDefaultLocation() {
    if (this.locationSelect) {
      this.locationSelect.selectedIndex = 0;
      this.selectedStoreLabel = null;
      this.updateStoreHighlight();
    }
  }

  generateStoreDetails(stores) {
    return stores
      .map(
        store => `
        <div class="store-details ${this.selectedStoreLabel === store.label ? 'selected' : ''}" data-label="${store.label}">
          <span class="location-check-icon"></span>
          <img src="${store.logo}" alt="${store.label}" style="max-width: 150px;">
          <h5>${store.label}</h5>
          <p><strong>Adresse:</strong> ${store.street}, ${store.city}, ${store.zip_code}, ${store.country}</p>
          <p><strong>Telefon:</strong> <a href="tel:${store.phone}">${store.phone}</a></p>
          <p><strong>Email:</strong> <a href="mailto:${store.email}">${store.email}</a></p>
          <p><strong>Mehr Infos:</strong> <a href="${store.url}" target="_blank">Hier klicken</a></p>
        </div>
      `
      )
      .join("");
  }

  updateStoreHighlight() {
    document.querySelectorAll(".store-details").forEach(storeElement => {
      const storeLabel = storeElement.getAttribute("data-label");
      storeElement.classList.toggle("selected", storeLabel === this.selectedStoreLabel);
    });
  }

  handleFormSubmit(event) {
    event.preventDefault();
    
    const selectedLocation = this.locationSelect.options[this.locationSelect.selectedIndex];
    const toEmailField = this.querySelector("#to_email");
    if (toEmailField && selectedLocation) {
      toEmailField.value = selectedLocation.getAttribute("datastoreemail");
    }

    if (!this.selectedStoreLabel) {
      this.errorMessages.innerHTML = `<div class="alert alert-danger">Bitte wählen Sie eine Filiale aus.</div>`;
      return;
    }

    if (this.contentWrapper) this.contentWrapper.classList.add('opacity_hide');
    if (this.mapLoader) this.mapLoader.removeAttribute('hidden');
    emailjs.sendForm(this.serviceID, this.templateID, this.locationForm)
      .then(() => {
        this.mapLoader.setAttribute("hidden", "true");
        this.contentWrapper.classList.remove('opacity_hide');
        this.errorMessages.innerHTML = `<div class="alert alert-success">Ihr Rezept wurde erfolgreich übermittelt.</div>`;
        this.locationForm.style.display = "none";
        setTimeout(() => {
          this.locationForm.reset();
          this.locationForm.style.display = "block";
          this.errorMessages.innerHTML = "";
        }, 6000);
      })
      .catch(() => {
        this.mapLoader.setAttribute("hidden", "true");
        this.contentWrapper.classList.remove('opacity_hide');
        this.errorMessages.innerHTML = `<div class="alert alert-danger">Ein Fehler ist aufgetreten.</div>`;
      });
  }
}

customElements.define("rezept-erfassen", RezeptErfassen);

// Event listener for switching selection on store click
document.addEventListener("click", function (event) {
  const storeElement = event.target.closest(".store-details");
  if (storeElement) {
    const selectedLabel = storeElement.getAttribute("data-label");
    const rezeptComponent = document.querySelector("rezept-erfassen");

    if (rezeptComponent) {
      rezeptComponent.autoSelectLocationByLabel(selectedLabel);
    }
  }
});


class ProductTimer extends HTMLElement {
  constructor() {
    super();
    this.targetDate = this.getAttribute("data-date"); // Target date in dd/mm/yyyy
    this.targetTime = this.getAttribute("data-time"); // Target time (e.g., '1pm')
    this.timer = null;
    this.lastValues = { days: null, hours: null, minutes: null, seconds: null };
  }

  connectedCallback() {
    this.daysElement = this.querySelector("#countdownDays");
    this.hoursElement = this.querySelector("#countdownHours");
    this.minutesElement = this.querySelector("#countdownMin");
    this.secondsElement = this.querySelector("#countdownSec");

    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown() {
    const endDate = this.parseDateTime(this.targetDate, this.targetTime);
    if (!endDate) {
      console.error("Invalid date or time format. Please use dd/mm/yyyy and a valid time format (e.g., '1pm').");
      return;
    }

    const endTime = endDate.getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const remainingTime = endTime - now;

      if (remainingTime < 0) {
        this.clearTimer();
        return;
      }

      const days = Math.floor(remainingTime / ProductTimer._day);
      const hours = Math.floor(
        (remainingTime % ProductTimer._day) / ProductTimer._hour
      );
      const minutes = Math.floor(
        (remainingTime % ProductTimer._hour) / ProductTimer._minute
      );
      const seconds = Math.floor(
        (remainingTime % ProductTimer._minute) / ProductTimer._second
      );

      this.updateDisplay(days, hours, minutes, seconds);

      this.timer = requestAnimationFrame(updateTimer);
    };

    updateTimer(); // Initial update
  }

  updateDisplay(days, hours, minutes, seconds) {
    const { lastValues } = this;

    if (this.daysElement && days !== lastValues.days) {
      this.daysElement.textContent = days;
      lastValues.days = days;
    }
    if (this.hoursElement && hours !== lastValues.hours) {
      this.hoursElement.textContent = hours;
      lastValues.hours = hours;
    }
    if (this.minutesElement && minutes !== lastValues.minutes) {
      this.minutesElement.textContent = minutes;
      lastValues.minutes = minutes;
    }
    if (this.secondsElement && seconds !== lastValues.seconds) {
      this.secondsElement.textContent = seconds;
      lastValues.seconds = seconds;
    }
  }

  clearTimer() {
    if (this.timer) {
      cancelAnimationFrame(this.timer);
      this.timer = null;
    }
    this.updateDisplay(0, 0, 0, 0);
  }

  parseDateTime(dateString, timeString) {
    if (!dateString) return null;

    const [day, month, year] = dateString.split("/").map(Number);
    if (
      isNaN(day) ||
      isNaN(month) ||
      isNaN(year) ||
      day < 1 ||
      day > 31 ||
      month < 1 ||
      month > 12
    ) {
      return null; // Invalid date
    }

    let timeParts = this.parseTime(timeString);
    if (!timeParts) {
      return null; // Invalid time
    }

    // Combine date and time into a single Date object
    return new Date(year, month - 1, day, timeParts.hours, timeParts.minutes);
  }

  parseTime(timeString) {
    if (!timeString) return { hours: 0, minutes: 0 }; // Default to midnight if no time is provided

    const timeRegex = /(\d+)(?::(\d+))?\s*(am|pm)?/i;
    const match = timeString.match(timeRegex);

    if (!match) {
      return null; // Invalid time format
    }

    let hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10) || 0;
    const period = match[3] ? match[3].toLowerCase() : null;

    if (period === "pm" && hours < 12) {
      hours += 12;
    } else if (period === "am" && hours === 12) {
      hours = 0;
    }

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      return null; // Invalid time values
    }

    return { hours, minutes };
  }

  static get _second() {
    return 1000;
  }
  static get _minute() {
    return this._second * 60;
  }
  static get _hour() {
    return this._minute * 60;
  }
  static get _day() {
    return this._hour * 24;
  }
}

// Define the custom element

customElements.define("product-timer", ProductTimer);

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const textElement = document.querySelector(
      "etrusted-rc-carousel-review-tile.review-tile-reduced .content .text"
    );
    if (textElement) {
      textElement.style.fontWeight = "400";
      console.log("Font-weight 400 applied to element.");
    } else {
      console.log("Element not found.");
    }
  }, 5000);
});